export default "__VITE_ASSET__sovyZaDO__"